import { createAsyncThunk } from "@reduxjs/toolkit";

import LocalStorage from "../../../../Services/Storage/LocalStorage";
import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";
import UserDashAPI, { UserDashApiUrls } from "../API/UserDashAPI";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const userDashAPI = new UserDashAPI(apiHelper, cache);

export const getDashboardData = createAsyncThunk(
  UserDashApiUrls.getUserDashData,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const UserId = state.auth.user.userId;

    const response = await userDashAPI.getUserDashData(payload, token);

    return response;
  }
);
